export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_1.fe5744ee.jpg";